/* Inline SVG icons ported verbatim from the approved prototype.
   Sizing/stroke comes from the surrounding CSS (.nav-item svg, .ev-trash svg, ...). */
export const IconGrid = () => (
  <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>
);

export const IconCal = () => (
  <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></svg>
);

export const IconLunch = () => (
  <svg viewBox="0 0 24 24"><path d="M4 19V6a2 2 0 0 1 2-2h9l5 5v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" /><path d="M14 4v5h5" /></svg>
);

export const IconMail = () => (
  <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>
);

export const IconFund = () => (
  <svg viewBox="0 0 24 24"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
);

export const IconUsers = () => (
  <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg>
);

export const IconRoomParents = () => (
  <svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.2" /><path d="M2.5 19.5c0-3.4 2.9-6 6.5-6s6.5 2.6 6.5 6" /><circle cx="17" cy="9" r="2.6" /><path d="M15 12.3c2.6.4 4.5 2.3 4.5 4.7" /></svg>
);

export const IconSignup = () => (
  <svg viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 3v3M16 3v3M8 12l2.5 2.5L16 9" /></svg>
);

export const IconConsent = () => (
  <svg viewBox="0 0 24 24"><path d="M20 7v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9l5 4Z" /><path d="M9 12.5l2 2 4-4.5" /></svg>
);

export const IconTodo = () => (
  <svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="4.5" /><path d="m8 12.4 2.6 2.6L16 9.6" /></svg>
);

/* Carries its own stroke so it also reads inside a .btn, which sizes an icon but
   sets no paint — without these it falls back to a solid fill and renders as a
   blob. The contexts that do style it (.nav-item, .tab-item, .mhead .ic) still
   win, since CSS beats a presentation attribute. */
export const IconLink = () => (
  <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round"><path d="M9 17H7a5 5 0 0 1 0-10h2M15 7h2a5 5 0 0 1 0 10h-2M8 12h8" /></svg>
);

/* Phosphor LinkSimple — the design's glyph on the .mini-row-copy pill */
export const IconLinkSimple = () => (
  <svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M165.66,90.34a8,8,0,0,1,0,11.32l-64,64a8,8,0,0,1-11.32-11.32l64-64A8,8,0,0,1,165.66,90.34ZM215.6,40.4a56,56,0,0,0-79.2,0L106.34,70.45a8,8,0,0,0,11.32,11.32l30.06-30a40,40,0,0,1,56.57,56.56l-30.07,30.06a8,8,0,0,0,11.31,11.32L215.6,119.6a56,56,0,0,0,0-79.2ZM138.34,174.22l-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z" /></svg>
);

export const IconSignOut = () => (
  <svg viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></svg>
);

export const IconChevron = ({ className = 'ctx-chev' }) => (
  <svg className={className} viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></svg>
);

export const IconClose = () => (
  <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" /></svg>
);

export const IconTrash = () => (
  <svg viewBox="0 0 256 256" fill="currentColor"><path d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16M96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0m48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0" /></svg>
);

export const IconEdit = () => (
  <svg viewBox="0 0 24 24"><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
);

export const IconPlus = () => (
  <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"><path d="M12 5v14M5 12h14" /></svg>
);

export const IconCheck = () => (
  <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"><path d="M20 6 9 17l-5-5" /></svg>
);

export const IconExport = () => (
  <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"><path d="M12 3v12M7 10l5 5 5-5M5 21h14" /></svg>
);

export const IconFile = () => (
  <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"><path d="M4 19V6a2 2 0 0 1 2-2h9l5 5v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" /></svg>
);

export const IconMenu = () => (
  <svg viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h16" /></svg>
);

export const IconEnvelope = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" strokeWidth="2"><path d="M4 4h16v16H4z" /><path d="m4 7 8 6 8-6" /></svg>
);
